
import { Game } from "@/models/Game";
import { GoalsList } from "@/models/MapPois/Quest/Goals";
import { ActionRefData, QuestMapPoi } from "@/models/MapPois/Quest/QuestMapPoi";
import { cloneDeep, isEqual } from "lodash";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import ActionBoxExit from "../../../Base/Actions/ExitActions/ActionBoxExit.vue";

@Component({
  components: {
    ActionBoxExit,
  },
})
class PoiExitGoals extends Vue {
  @Prop({ default: null }) readonly mapPoi!: QuestMapPoi;
  @Prop({ default: null }) readonly contentString!: string;
  @Prop({ default: null }) readonly contentId!: number;
  @Prop({ default: null }) readonly gameData!: Game;
  @Prop({ default: false }) readonly isSavedOrDiscard!: boolean;
  @Prop({ default: false }) readonly isEditingLocked!: boolean;

  showSavePanel = false;
  cloneMapPoi = {} as QuestMapPoi;

  get getContentData(): GoalsList | undefined {
    return this.mapPoi.contentGroups[this.contentString].exitGoals;
  }
  created(): void {
    this.cloneMapPoi = cloneDeep(this.mapPoi);
    if (this.mapPoi.contentGroups[this.contentString].exitGoals === undefined) {
      this.mapPoi.contentGroups[this.contentString].exitGoals = {};
    }
  }

  onValueChanged(): void {
    if (!isEqual(this.mapPoi, this.cloneMapPoi)) {
      this.showSavePanel = true;
    } else {
      this.showSavePanel = false;
    }
    this.$emit("updateTempObject", this.mapPoi);
  }

  update(contentData: any): void {
    try {
      if (contentData.objectName !== "playTimerGoal") {
        this.addActionRefActions(contentData);
      }
      this.mapPoi.contentGroups[this.contentString].exitGoals =
        contentData.contentData;
      this.onValueChanged();
    } catch (error) {
      console.log(error);
    }
  }

  deleteAction(contentData: any): void {
    this.mapPoi.contentGroups[this.contentString].exitGoals =
      contentData.contentData;
    this.deleteActionRefAction(contentData);
    var data = {
      mapPoi: this.mapPoi,
      game_uid: this.gameData.key,
    };
    this.$store.dispatch("mapPoiStore/updateMapPoiType", data);
  }

  addActionRefActions(contentData: any): void {
    if (this.mapPoi.actionGoalRef === undefined) {
      this.mapPoi.actionGoalRef = [];
    }
    this.deleteActionRefAction(contentData);
    var actionItems = Object.values(contentData.actionDetails.req);
    actionItems.forEach((x: any) => {
      var data: ActionRefData = {
        id: x.id,
        helperPath: this.getHelperPath(contentData.objectName),
        path: this.getRealPath(contentData.objectName),
      };
      this.mapPoi.actionGoalRef?.push(data);
    });
  }

  deleteActionRefAction(contentData: any): void {
    var data = this.mapPoi.actionGoalRef?.filter(
      (x: any) => x.path === this.getRealPath(contentData.objectName)
    );
    data?.forEach((x) => {
      this.mapPoi.actionGoalRef?.splice(
        this.mapPoi.actionGoalRef?.indexOf(x),
        1
      );
    });
  }

  getHelperPath(objectName: string): string {
    return (
      this.mapPoi.title.en +
      "/" +
      "Content Group" +
      this.contentId +
      "/ Exit Goals /" +
      objectName
    );
  }
  getRealPath(objectName: string): string {
    return (
      this.mapPoi.key +
      "/contentGroups/" +
      this.contentString +
      "/exitGoals/" +
      objectName
    );
  }
}

export default PoiExitGoals;
